import React from "react";
import { Monitor, Smartphone } from "lucide-react";

/** Görevin hangi uygulamadan oluşturulduğunu gösteren küçük ikon.
 *
 *  ESKİ görevlerde `created_client` alanı YOKTUR (null) → hiç ikon çizilmez.
 *  Rol veya ekip görünümü kapısı YOKTUR; her kullanıcıda aynı şekilde görünür.
 */
export const TaskSourceIcon = ({ task, className = "" }) => {
  const src = task?.created_client;
  if (src !== "web" && src !== "mobile") return null;
  const Icon = src === "mobile" ? Smartphone : Monitor;
  return (
    <span
      data-testid={`task-source-${task.id}`}
      data-source={src}
      title={src === "mobile" ? "Telefondan oluşturuldu" : "Web'den oluşturuldu"}
      className={`inline-flex items-center align-middle shrink-0 opacity-70 ${className}`}
    >
      <Icon className="h-2.5 w-2.5" />
    </span>
  );
};

export default TaskSourceIcon;
